import React from 'react';
import { useTranslation } from 'react-i18next';

const StakeholderTipLinkContent = () => {
  const { t } = useTranslation();
  return (
    <p>{t('tipStakeholderLink')}</p>
  );
};

export default StakeholderTipLinkContent;
